import { useEffect, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faSave } from "@fortawesome/free-solid-svg-icons";
import { hideSideBarDesktop, soloNumero } from "../../utils/funciones";
import { useAjustesDias } from "./useAjustesDias";
import { DataContextContractual } from "../../contextData/contextData";


export const AjustesDeDias = () => {
  const { edit, setEdit, enviar } = useAjustesDias();
  const { diasAnticipo, setDiasAnticipo } = useContext(DataContextContractual);


  useEffect(() => {
    hideSideBarDesktop();
  }, []);

  return (
    <div className="d-flex align-items-center flex-column h-100">
      <div className="p-4 border rounded-10 mt-5">
        <div className="d-flex align-items-center gap-3">
          <label htmlFor="horas">Días de anticipación para solicitudes</label>
          <input
            disabled={!edit}
            style={{ width: "50px" }}
            className="form-control text-center px-0"
            type="text"
            value={diasAnticipo}
            onChange={(e) => {
              setDiasAnticipo(soloNumero(e.target.value));
            }}
          />
          {!edit ? (
            <button
              className="btn btn-md btn-primary"
              onClick={() => {
                setEdit(true);
              }}
            >
              Editar
              <FontAwesomeIcon icon={faEdit} className="ms-2" size="lg" />
            </button>
          ) : (
            <button
              className="btn btn-md btn-success"
              onClick={() => {
                enviar(diasAnticipo);
              }}
            >
              Guardar
              <FontAwesomeIcon icon={faSave} className="ms-2" size="lg" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
